"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
exports.__esModule = true;
var logs_1 = require("@ledgerhq/logs");
var bignumber_js_1 = require("bignumber.js");
var errors_1 = require("@ledgerhq/errors");
var isValidRecipient_1 = require("../../libcore/isValidRecipient");
var buildBigNumber_1 = require("../../libcore/buildBigNumber");
var transaction_1 = require("./transaction");
var promise_1 = require("../../promise");
var transaction_2 = require("./transaction");
function bitcoinBuildTransaction(_a) {
    var account = _a.account, core = _a.core, coreAccount = _a.coreAccount, coreCurrency = _a.coreCurrency, transaction = _a.transaction, isPartial = _a.isPartial, isCancelled = _a.isCancelled;
    return __awaiter(this, void 0, void 0, function () {
        var currency, perCoin, recipient, bitcoinLikeAccount, isValid, feePerByte, fees, transactionBuilder, utxoStrategy, count, objects, utxos, syncReplaceAddress_1, utxos_1, utxos_1_1, utxo, s, e_1_1, amount, builded;
        var e_1, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    currency = account.currency;
                    perCoin = transaction_2.perCoinLogic[currency.id];
                    recipient = (perCoin === null || perCoin === void 0 ? void 0 : perCoin.asLibcoreTransactionRecipient)
                        ? perCoin.asLibcoreTransactionRecipient(transaction.recipient)
                        : transaction.recipient;
                    return [4 /*yield*/, coreAccount.asBitcoinLikeAccount()];
                case 1:
                    bitcoinLikeAccount = _c.sent();
                    return [4 /*yield*/, (0, isValidRecipient_1.isValidRecipient)({
                            currency: currency,
                            recipient: recipient
                        })];
                case 2:
                    isValid = _c.sent();
                    if (isValid !== null) {
                        throw new errors_1.InvalidAddress("", {
                            currencyName: currency.name
                        });
                    }
                    feePerByte = transaction.feePerByte;
                    if (!feePerByte)
                        throw new errors_1.FeeNotLoaded();
                    return [4 /*yield*/, (0, buildBigNumber_1.bigNumberToLibcoreAmount)(core, coreCurrency, new bignumber_js_1.BigNumber(feePerByte))];
                case 3:
                    fees = _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    return [4 /*yield*/, bitcoinLikeAccount.buildTransaction(isPartial)];
                case 4:
                    transactionBuilder = _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    utxoStrategy = transaction.utxoStrategy;
                    if (!transaction.useAllAmount) return [3 /*break*/, 6];
                    return [4 /*yield*/, transactionBuilder.wipeToAddress(recipient)];
                case 5:
                    _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    _c.label = 6;
                case 6: return [4 /*yield*/, bitcoinLikeAccount.getUTXOCount()];
                case 7:
                    count = _c.sent();
                    return [4 /*yield*/, bitcoinLikeAccount.getUTXO(0, count)];
                case 8:
                    objects = _c.sent();
                    return [4 /*yield*/, (0, promise_1.promiseAllBatched)(6, objects, transaction_2.parseBitcoinUTXO)];
                case 9:
                    utxos = _c.sent();
                    if (perCoin) {
                        syncReplaceAddress_1 = perCoin.syncReplaceAddress;
                        if (syncReplaceAddress_1) {
                            utxos = utxos.map(function (u) { return (__assign(__assign({}, u), { address: u.address && syncReplaceAddress_1(account, u.address) })); });
                        }
                    }
                    _c.label = 10;
                case 10:
                    _c.trys.push([10, 15, 16, 17]);
                    utxos_1 = __values(utxos), utxos_1_1 = utxos_1.next();
                    _c.label = 11;
                case 11:
                    if (!!utxos_1_1.done) return [3 /*break*/, 14];
                    utxo = utxos_1_1.value;
                    s = (0, transaction_1.getUTXOStatus)(utxo, utxoStrategy);
                    if (!s.excluded) return [3 /*break*/, 13];
                    (0, logs_1.log)("bitcoin", "excludeUTXO ".concat(utxo.hash, "@").concat(utxo.outputIndex, " (").concat(s.reason, ")"));
                    return [4 /*yield*/, transactionBuilder.excludeUtxo(utxo.hash, utxo.outputIndex)];
                case 12:
                    _c.sent();
                    _c.label = 13;
                case 13:
                    utxos_1_1 = utxos_1.next();
                    return [3 /*break*/, 11];
                case 14: return [3 /*break*/, 17];
                case 15:
                    e_1_1 = _c.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 17];
                case 16:
                    try {
                        if (utxos_1_1 && !utxos_1_1.done && (_b = utxos_1["return"])) _b.call(utxos_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 17:
                    if (!!transaction.useAllAmount) return [3 /*break*/, 20];
                    if (!transaction.amount)
                        throw new Error("amount is missing");
                    return [4 /*yield*/, (0, buildBigNumber_1.bigNumberToLibcoreAmount)(core, coreCurrency, new bignumber_js_1.BigNumber(transaction.amount))];
                case 18:
                    amount = _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    return [4 /*yield*/, transactionBuilder.sendToAddress(amount, recipient)];
                case 19:
                    _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    _c.label = 20;
                case 20: return [4 /*yield*/, transactionBuilder.pickInputs(utxoStrategy.strategy, 0
                    /* not used, out of int32 range issue. patched in signature time. */
                    )];
                case 21:
                    _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    return [4 /*yield*/, transactionBuilder.setFeesPerByte(fees)];
                case 22:
                    _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    return [4 /*yield*/, transactionBuilder.build()];
                case 23:
                    builded = _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    return [2 /*return*/, builded];
            }
        });
    });
}
exports["default"] = bitcoinBuildTransaction;
//# sourceMappingURL=libcore-buildTransaction.js.map